var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.502193 15.2922L3.67574 15.4083C3.70807 16.6466 3.98802 17.6243 4.36642 18.2481L4.36647 18.2482C4.90145 19.1293 5.71239 19.5137 6.53915 19.5137C7.04875 19.5137 7.55946 19.4473 8.16236 19.0548C8.75133 18.6714 9.41416 17.9862 10.2649 16.7882L10.265 16.7881C11.2253 15.4346 12.3092 13.6916 13.2383 12.1977C13.622 11.5807 13.9793 11.0062 14.2906 10.5192L14.2906 10.5192L16.1063 7.67703C16.1063 7.67701 16.1063 7.67699 16.1063 7.67697C17.3702 5.6999 18.8126 3.53532 20.4578 2.07544L20.4579 2.07535C21.7934 0.888859 23.2113 0.25 24.617 0.25C26.9998 0.25 29.304 1.65499 31.0884 4.36458C33.044 7.33574 34 11.089 34 14.9757C34 17.2759 33.5548 18.946 32.8121 20.2551L32.812 20.2553C32.1306 21.4579 30.8317 22.657 28.6555 22.7426V19.5033C29.1085 19.4696 29.4975 19.343 29.8262 19.1336C30.213 18.8872 30.5009 18.5362 30.7121 18.1216C31.13 17.3008 31.2595 16.2062 31.2595 15.0797C31.2595 11.8693 30.5256 8.28682 28.8879 5.71129L28.8879 5.71126C27.7274 3.88676 26.1847 2.71267 24.4389 2.71267C22.5384 2.71267 21.06 4.17629 19.4743 6.57759C18.6235 7.8645 17.7518 9.43109 16.7803 11.1855L15.7094 13.1183L15.7093 13.1183C13.5578 17.0034 13.0189 17.8752 11.9544 19.3223C11.0214 20.5874 10.1696 21.4416 9.30379 21.9805C8.44349 22.516 7.55751 22.7475 6.54039 22.7475C4.11755 22.7475 2.60765 21.6885 1.66592 20.0905L1.66566 20.09C0.923231 18.8362 0.534481 17.1904 0.502193 15.2922Z",
    fill: "#0081FB",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2575 15.3244L33.9969 15.2364C33.9647 17.4042 33.5254 18.998 32.8108 20.2577L32.8108 20.2578C32.1037 21.5058 30.7316 22.75 28.4042 22.75C27.6664 22.75 26.9843 22.6684 26.3108 22.42C25.6382 22.1719 24.9611 21.7526 24.241 21.0607L24.2409 21.0605C23.1272 19.992 21.8087 18.075 20.7864 16.333L20.7863 16.3329L17.7377 11.1457C17.7377 11.1457 17.7377 11.1457 17.7377 11.1457C16.2047 8.53581 14.7906 6.57766 13.9595 5.67947C13.0877 4.73719 11.8988 3.51296 9.98636 3.51296C8.47186 3.51296 7.21824 4.5483 6.19719 6.04778L3.49582 4.41207C5.14635 1.92572 7.45127 0.251282 10.0461 0.251282C11.6009 0.251282 13.1486 0.71729 14.7794 2.0731L14.7794 2.07314C16.5791 3.56845 18.5143 6.04598 20.947 10.1729C20.947 10.1729 20.947 10.1729 20.947 10.1729L21.8212 11.6567L21.8212 11.6568C23.9295 15.2334 25.1377 17.0896 25.8536 17.9751L25.8537 17.9752C26.3134 18.5429 26.7191 18.9302 27.1292 19.1743C27.5465 19.4226 27.9555 19.515 28.4055 19.515C28.9671 19.515 29.4385 19.3831 29.8262 19.1362C30.213 18.8898 30.5009 18.5387 30.7121 18.1241C31.1 17.3623 31.2394 16.3646 31.2575 15.3244Z",
    fill: "url(#paint0_linear_801_642)",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79203 0.255361L9.74014 3.51961C8.26964 3.63001 7.05307 4.72361 6.06302 6.24695C4.57342 8.53609 3.67261 11.9225 3.67261 15.1672C3.67261 16.3857 3.90888 17.3703 4.25006 18.0388L1.53444 19.8605C0.845997 18.5782 0.5 16.9248 0.5 15.0328C0.5 11.3713 1.48749 7.55999 3.35637 4.62521C4.96242 2.10414 7.22757 0.363685 9.79203 0.255361Z",
    fill: "url(#paint1_linear_801_642)",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_801_642",
    x1: 7.62014,
    y1: 10.9034,
    x2: 31.0321,
    y2: 12.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_801_642",
    x1: 5.14781,
    y1: 16.7369,
    x2: 5.14781,
    y2: 7.94746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.809593945a4858c6743c3db14904c3ab.svg";
export { ForwardRef as ReactComponent };